import { render, staticRenderFns } from "./number.vue?vue&type=template&id=f67e4240&scoped=true&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"
import style0 from "./number.vue?vue&type=style&index=0&id=f67e4240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67e4240",
  null
  
)

export default component.exports